// extracted by mini-css-extract-plugin
export default {"index":"favoriteObjects_index__+WGhr"};